const debug = false

/**
 * 
 * Variables
 * 
 */

const 
    searchPage = (window.location.pathname !== '/') ? true : false,

    // Environment and API variables
    myAyaUrl = document.querySelector('html').dataset.myaya || `my`,
    coreApi = document.querySelector('html').dataset.core || `api`,
    baseEnv = (myAyaUrl == 'my') ? '' : myAyaUrl.slice(2),
    requestOptions = { method: 'GET', redirect: 'follow' },

    // Specialties variables
    specialtyListContainer = document.getElementById('specialtyListContainer'),
    chipsSpecialtyContainer = document.getElementById('chipsSpecialty'),
    specialtyInput = document.getElementById("specialtyInput"),
    mobileSpecialtyChipCountContainer = document.getElementById('chip-count-specialties'),
    specialtyWrapper = document.getElementById("specialtyWrapper"),
    specialtyOptions = specialtyWrapper.querySelector("#specialtyWrapper .options"),
    specialtySelectBtn = specialtyWrapper.querySelector(".select-btn--specialty"),
    mobileWrapperSpecialtyCloseBtn = document.querySelector('#specialtyWrapper .aya-search-menu--mobile--close'),
    mobileWrapperSpecialtyCloseBtn2 = document.querySelector('#specialtyWrapper .mobile-menu-done'),
    clearSpecialtyFilterBtn = specialtyWrapper.querySelectorAll('.clear-filters'),
    includeSpecialtiesToggle = document.querySelector('#specialtyWrapper .include-specialties a'),

    // Locations variables
    locationListContainer = document.getElementById('locationListContainer'),
    chipsLocationContainer = document.getElementById('chipsLocation'),
    locationsInput = document.getElementById("locationsInput"),
    mobileLocationChipCountContainer = document.getElementById('chip-count-locations'),
    locationWrapper = document.getElementById("locationWrapper"),
    locationsOptions = locationWrapper.querySelector(".options"),
    locationSelectBtn = locationWrapper.querySelector(".select-btn--location"),
    mobileWrapperLocationCloseBtn = document.querySelector('#locationWrapper .aya-search-menu--mobile--close'),
    mobileWrapperLocationCloseBtn2 = document.querySelector('#locationWrapper .mobile-menu-done'),
    clearLocationFiltersBtn = locationWrapper.querySelectorAll('.clear-filters'),

    // Additional variables
    // clearAllFiltersBtn = document.querySelector('.clear-all-filters'),

    // Jobs and job listings variables
    jobDetailsContainer = document.getElementById('jobDetails'),
    paginationText = document.getElementById('paginationText'),
    // resultsLimit = 3000,
    resultsLimit = 10,
    searchLoader = document.getElementById('search-loader'),

    // Registration
    emailCheckField = document.getElementById('emailCheck'),
    emailField = document.getElementById('email'),
    getstarted = document.getElementById('getstarted'),

    // Misc variables for layout
    hero = document.getElementById('hero'),
    navOverlay = document.getElementById('nav-overlay'),
    mq = window.matchMedia("screen and (max-width: 767px)"),

    // Default level 1 markup for the specialties dropdown
    menuLevel1 = `
        <li class="parent parent--default">
            <a href="#" class="header header--default">Nursing</a>
        </li>
        <li class="parent parent--default">
            <a href="#" class="header header--default">Allied</a>
        </li>
        <li class="parent parent--default">
            <a href="#" class="header header--default">Non Clinical</a>
        </li>`;

let 
    filtersArray  = [], 
    initialSearch = true,
    fullArr  = [], 
    searchResults = [], 
    locationSearchResults = [], 
    selectedStates = [], 
    selectedCities = [], 
    selectedExpertises = [],  
    jobsData = [],
    isSearch = false, 
    isLocationSearch = false, 
    mobileMenuInputActive = false, 
    citiesMarkupAdded = false,
    locationsMarkupAdded = false,
    documentClicked = false,
    additionalChipsCountText = ``, 
    citiesMarkup = ``, 
    additionalLocationChipsCountText = ``,
    uniqueJobsCount, 
    totalJobsCount, 
    jobDetailData, 
    apiUrl,
    locations,
    currClicked = {},
    heroOffset = 0, 
    offset = 0, 
    totalJobPages,
    jobsPerPage = 10,
    includeSpecialties = false,
    additionalChipsCount = 0, 
    totalChipsCount = 0, 
    totalLocationChipsCount = 0, 
    additionalLocationChipsCount = 0,
    currPage = 1,
    offsetHeightForNav = (!searchPage) ? 170 : 170,
    userEmail = '',
    cdnUrl = ``,
    schoolExpertises = ["666", "685", "639", "648", "657", "675", "1199", "916", "917", "933", "930", "931", "260", "910", "925", "911", "921", "912", "913", "1198", "918", "914", "915", "1254", "919", "920", "922", "923", "924"],
    schoolProfessions = ["100", "91", "29", "2", "5", "1", "940", "941"]
    h1 = document.querySelector('#hero-headers h1'),
    h2 = document.querySelector('#hero-headers h2');



/**
 * 
 * Event Listeners
 * 
 */

// Sets the correct hero position as you resize
window.addEventListener('resize', () => {setHeroPosition()}, true);

// Focus and click listeners to properly toggle the menus
specialtyInput.addEventListener("focus", () => openMenu(specialtyWrapper));
specialtySelectBtn.addEventListener("click", () => toggleMenu(specialtyWrapper));
locationSelectBtn.addEventListener("click", () => toggleMenu(locationWrapper));
mobileWrapperSpecialtyCloseBtn.addEventListener('click', (e) => {e.preventDefault(); toggleMenu(specialtyWrapper)});
mobileWrapperSpecialtyCloseBtn2.addEventListener('click', (e) => {e.preventDefault(); toggleMenu(specialtyWrapper)});
mobileWrapperLocationCloseBtn.addEventListener('click', (e) => {e.preventDefault(); toggleMenu(locationWrapper)});
mobileWrapperLocationCloseBtn2.addEventListener('click', (e) => {e.preventDefault(); toggleMenu(locationWrapper)});

// Click listener to clear dropdowns
// clearAllFiltersBtn.addEventListener('click', (e) => {e.preventDefault(); clearDropdown('all')})

// On mobile, open the locations menu on input focus
if (window.matchMedia('screen and (max-width: 767px)').matches) {
    locationsInput.addEventListener("focus", () => openMenu(locationWrapper));
}

// Track clicks and close out the menus if clicking outside of them
document.addEventListener('click', function({ target } ){
    documentClicked = true
    if (!target.closest('.menu--active')) {
        specialtyWrapper.classList.remove('menu--active')
        locationWrapper.classList.remove('menu--active')
        if (window.matchMedia('screen and (min-width: 768px)').matches && searchPage) {
            navOverlay.classList.add('is-invisible')
        }
    } 
}, true)



/**
 * Returns the height of an element including margin and padding
 *
 * @param {element} el The element to calculate the height of
 * @return {number} el height plus margin/padding
 */
const outerHeight = (el) => {
    // if (debug) console.log('fn: outerheight')
    const height = el.offsetHeight,
        style = window.getComputedStyle(el)

    return ['top', 'bottom']
        .map(side => parseInt(style[`margin-${side}`]))
        .reduce((total, side) => total + side, height)
}




/**
 * Slugifies a string by replacing non-alphanum chars with dashes
 *
 * @param {string} str The string to slugify
 * 
 */
const makeSlug =  (str) => {
    str = str.toLowerCase();
    str = str.replace(/[^a-z0-9]+/g, '-');
    str = str.replace(/^-+|-+$/g, '');
    return str;
}



/**
 * 
 * Modifies the hero element's top position
 * Used only on the search page
 *
 */
const setHeroPosition = () => {
    // if (debug) console.log('fn: setheropos')
    if (searchPage) {
        let calculatedHeightH1 = outerHeight(document.getElementsByTagName('h1')[0]),
            calculatedHeightH2 = outerHeight(document.querySelector('h1 + p'))

        let combinedHeight = (calculatedHeightH1 + calculatedHeightH2) * -1
        let positioningOffset = (window.matchMedia('screen and (min-width: 1024px)').matches) ? 50 : 30
        let offsetHero = combinedHeight + document.getElementsByTagName('header')[0].offsetHeight - positioningOffset
        hero.style.top = offsetHero + 'px'
    }
}
setHeroPosition()



/**
 * Clears the specified dropdown, resets the input val, removes chips
 *
 * @param {string} dropdown The dropdown to reset (specialties, locations, all)
 */
const clearDropdown = (dropdown) => {
    if (debug) console.log('fn: cleardropdown')
    let chips;
    switch (dropdown) {
        case 'specialties':
            selectedExpertises = []
            chips = chipsSpecialty.querySelectorAll('.chip')
            chips.forEach((chip) => {
                removeChip(chip)
            })
            specialtyInput.value = ''
            reset()
            break
        case 'locations':
            selectedCities = []
            selectedStates = []
            chips = chipsLocation.querySelectorAll('.chip')
            chips.forEach((chip) => {
                removeLocationChip(chip)
            })
            locationsInput.value = ''
            resetLocations()
            break
        case 'all':
            removeAllChips()
            locationsInput.value = ''
            specialtyInput.value = ''
            reset()
            resetLocations()
            break
        default:
            break
    }
}



/**
 * 
 * Specifically clear out the specialties dropdown
 * 
 */
clearSpecialtyFilterBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault()
        clearDropdown('specialties')
    })
})



/**
 * 
 * Specifically clear out the locations dropdown
 * 
 */
clearLocationFiltersBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault()
        clearDropdown('locations')
    })
})



/**
 * 
 * Move the input menu on the fly if we're in a mobile view
 * This avoids duplicative DOM elements
 * @param {element} menu The element to move in the DOM
 */
const mobileMenuInput = (menu) => {    
    if (debug) console.log('fn: mobilemenuinput')
    let input = menu.querySelector('.chips--container')
    let element = menu.querySelector('.aya-search-menu--mobile')
    element.after(input);
    mobileMenuInputActive = true
}



/**
 * 
 * Moves the input and chips back to the original DOM location
 * @param {element} menu The element to move in the DOM back to original position
 * 
 */
const resetMobileMenuInput = (menu) => {
    if (debug) console.log('fn: resetmobilemenuinput')
    let input = menu.querySelector('.chips--container')
    let element = menu.querySelector('.select-btn')
    element.before(input);
    mobileMenuInputActive = false
}



/**
 * 
 * Close the menu
 * @param {element} menu The element to close
 * 
 */
const closeMenu = (menu) => {
    if (debug) console.log('fn: closemenu')
    menu.classList.remove('menu--active')

    if (window.matchMedia('screen and (max-width: 767px)').matches) {
        resetMobileMenuInput(menu)
        document.querySelector('html').classList.remove('is-clipped')
    }

    if (window.matchMedia('screen and (min-width: 768px)').matches && searchPage) {
        navOverlay.classList.add('is-invisible')
    }
}



/**
 * 
 * Open the menu
 * @param {element} menu The element to open
 * 
 */
const openMenu = (menu) => {
    if (debug) console.log('fn: openmenu')
    specialtyWrapper.classList.remove('menu--active')
    locationWrapper.classList.remove('menu--active')
    menu.classList.add('menu--active')
    if (window.matchMedia('screen and (max-width: 767px)').matches) {
        document.querySelector('html').classList.add('is-clipped')
        if (!mobileMenuInputActive) {
            mobileMenuInput(menu)
        }
        if (searchPage) {
            document.querySelector('header.header').classList.add('filter-open')
        }
    }
    if (window.matchMedia('screen and (min-width: 768px)').matches && searchPage) {
        navOverlay.classList.remove('is-invisible')
    }

    // We need to delay the displaying of cities because it lags on iOS safari :(
    if (menu === locationWrapper && !citiesMarkupAdded) {

        let hiddenOpts = document.querySelectorAll('.options li.hide-el')
        setTimeout(() => {
            hiddenOpts.forEach((h) => {
                h.classList.remove('hide-el')
            })
        }, 300);

        citiesMarkupAdded = true
    }
}



/**
 * 
 * Toggle the state of the menu
 * @param {element} menu The element to toggle the state of
 * 
 */
const toggleMenu = (menu) => {
    if (debug) console.log('fn: togglemenu')
    menu.classList.toggle('menu--active')

    // Do this to the menu on mobile
    if (window.matchMedia('screen and (max-width: 767px)').matches) {

        if (menu.classList.contains('menu--active') && !mobileMenuInputActive) {
            mobileMenuInput(menu)
        } else {
            resetMobileMenuInput(menu)
        }

        if (menu.classList.contains('menu--active')) {
            document.querySelector('html').classList.add('is-clipped')
        } else {
            document.querySelector('html').classList.remove('is-clipped')
        }
    }

    // Do this to the menu on non-mobile (search page only)
    if (window.matchMedia('screen and (min-width: 768px)').matches && searchPage) {
        if (menu.classList.contains('menu--active')) {
            navOverlay.classList.remove('is-invisible')
        } else {
            navOverlay.classList.add('is-invisible')
        }
    }

    // Do this to the active menu on mobile (search page only)
    if (menu.classList.contains('menu--active') && searchPage && window.matchMedia('screen and (max-width: 767px)').matches) {
        document.querySelector('header.header').classList.add('filter-open')
    }

    // Do this to the inactive menu on mobile (search page only)
    if (!menu.classList.contains('menu--active') && searchPage && window.matchMedia('screen and (max-width: 767px)').matches) {
        document.querySelector('header.header').classList.remove('filter-open')
    }

    // Do this to the active locations menu if cities haven't been loaded
    if (menu === locationWrapper && menu.classList.contains('menu--active') && !citiesMarkupAdded) {
        let hiddenOpts = document.querySelectorAll('.options li.hide-el')
        setTimeout(() => {
            hiddenOpts.forEach((h) => {
                h.classList.remove('hide-el')
            })
        }, 300);
        citiesMarkupAdded = true
    }
}



/**
 * 
 * If we're on the search page, we need to focus on the 
 * input field when clicking the chips container
 * 
 */
if (searchPage) {
    if (debug) console.log('if: searchpage')
    chipsSpecialtyContainer.addEventListener('click', function() {
        specialtyInput.focus()
    })
    
    chipsLocationContainer.addEventListener('click', function() {
        locationsInput.focus()
    })
}



/**
 * 
 * Get the data from the API
 * @return {object} jobLookups object containing expertises, professions, states, and cities
 * @return {object} professionsWithTypes object containing professions and their type
 * 
 */
// async function fetchData() {
//     if (debug) console.log('fn: fetchdata')
//     const [jobLookupsResponse, professionsWithTypesResponse] = await Promise.all([
//         fetch(`https://${coreApi}.ayahealthcare.com/Shifts/Jobs/Filters`, requestOptions),
//         fetch(`https://${coreApi}.ayahealthcare.com/AyaHealthCareWeb/job/ProfessionsWithTypes`, requestOptions),
//     ]);

//     const jobLookups = await jobLookupsResponse.json();
//     const professionsWithTypes = await professionsWithTypesResponse.json();

//     return [jobLookups, professionsWithTypes];
// }

async function fetchData() {
    if (debug) console.log('fn: fetchdata')
    const [jobLookupsResponse] = await Promise.all([
        fetch(`https://${coreApi}.ayahealthcare.com/Shifts/Jobs/Filters`, requestOptions),
    ]);

    const jobLookups = await jobLookupsResponse.json();
    return [jobLookups];
}



/**
 * 
 * Remove all of theh chips
 * 
 */
const removeAllChips = () => {
    if (debug) console.log('fn: removeallchips')
    totalChipsCount = 0
    totalLocationChipsCount = 0
    let chips = document.querySelectorAll('#search-menu .chip')
    let chipsMore = document.querySelectorAll('.chip--more')
    let expertises = document.querySelectorAll('.expertise.checked, .expertise--all.checked');
    let states = document.querySelectorAll('.state.checked, .state--all.checked');
    let cities = document.querySelectorAll('.city.checked, .city--all.checked');
    chipsMore.forEach((cm) => {
        cm.remove()
    })
    chips.forEach((chip) => {
        chip.remove()
    })
    expertises.forEach((exp) => {
        exp.classList.remove('checked')
    })
    states.forEach((state) => {
        state.classList.remove('checked')
    })
    // cities.forEach((city) => {
    //     city.classList.remove('checked')
    // })
    selectedExpertises = []
    selectedStates = []
    // selectedCities = []

    // Display the total specialty chip count on mobile
    mobileSpecialtyChipCountContainer.classList.add('hide-el')
    mobileSpecialtyChipCountContainer.querySelector('.chip-count').innerHTML = totalChipsCount

    // Display the total location chip count on mobile
    mobileLocationChipCountContainer.classList.add('hide-el')
    mobileLocationChipCountContainer.querySelector('.chip-count').innerHTML = totalLocationChipsCount

    // On mobile we need to recalculate the active menu's content's height so it fills the screen
    if (window.matchMedia('screen and (max-width: 767px)').matches) {
        if (document.getElementById('specialtyListContainer').querySelector('.chips--container')) {
            let inputHeight = document.getElementById('specialtyListContainer').querySelector('.chips--container').offsetHeight
            inputHeight += offsetHeightForNav
            if (CSS.supports(`( max-height: calc(100dvh - ${inputHeight}px) )`)) {
                specialtyOptions.style.maxHeight = `calc(100dvh - ${inputHeight}px)`
            } else {
                specialtyOptions.style.maxHeight = `calc(100vh - ${inputHeight}px)`
            }
        }

        if (document.getElementById('locationListContainer').querySelector('.chips--container')) {
            let inputHeight2 = document.getElementById('locationListContainer').querySelector('.chips--container').offsetHeight
            inputHeight2 += offsetHeightForNav
            if (CSS.supports(`( max-height: calc(100dvh - ${inputHeight2}px) )`)) {
                locationsOptions.style.maxHeight = `calc(100dvh - ${inputHeight2}px)`
            } else {
                locationsOptions.style.maxHeight = `calc(100vh - ${inputHeight2}px)`
            }
        }        
    }

}



/**
 * 
 * Remove a specific specialty chip
 * @param {element} chip The chip element we want to remove
 * 
 */
const removeChip = (chip) => {
    if (debug) console.log('fn: removechip', chip)
    // Update the global selectedExpertises var
    selectedExpertises = selectedExpertises.filter(obj => {
        return chip.dataset.expertisecode !== obj.expertiseCode;
    });
    chip.remove()
    
    // Get all of the checked expertises and uncheck them
    let expertises = document.querySelectorAll('.expertise.checked');
    expertises.forEach((exp) => {
        if (exp.dataset.professioncode === chip.dataset.professioncode && exp.dataset.expertisecode === chip.dataset.expertisecode) {
            exp.classList.remove('checked')
        }
    })
   
    // Now that we have an updated value for selectedExpertises, redo the chips
    addChips();
}



/**
 * 
 * Remove a specific location chip
 * @param {element} chip The chip element we want to remove
 * 
 */
const removeLocationChip = (chip) => {
    if (debug) console.log('fn: removelocationchip')
    // Update the global selectedStates var
    selectedStates = selectedStates.filter(obj => {
        if (!chip.dataset.city) {
            return chip.dataset.statecode.toString() !== obj.code;
        } else {
            return selectedStates
        }
    });

    chip.remove()
    
    // Get all selected states and uncheck them
    let states = document.querySelectorAll('.state.checked');
    states.forEach((state) => {
        if (!chip.dataset.city && state.dataset.code.toString() === chip.dataset.statecode.toString()) {
            state.classList.remove('checked')
        }
    })

    // Now we have updated arrays for selected cities and states so redo the chips
    addLocationChips();
}



/**
 * 
 * Update the URL history state when selections change and also push to datalayer
 * 
 */
const updateHistory = () => {
    if (debug) console.log('fn: updatehistory')
    let params = new URLSearchParams();
    let qs = ``
    let currExpertises = selectedExpertises

    let dl = {}
    dl.specialty = []
    dl.state = []
    dl.city = []

    currExpertises.forEach((exp, index) => {
        if (index === 0) {
            params.append('profession', exp.professionCode)
            params.append('specialty', exp.expertiseCode)

            dl.profession = exp.professionText
            dl.specialty.push(exp.expertiseText)
            dl.type = exp.professionType

        } else {
            params.append('specialty', exp.expertiseCode)
            
            dl.specialty.push(exp.expertiseText)
        }   
    });

    let inputStates = selectedStates
    
    inputStates.forEach((exp, index) => {
        params.append('state', exp.name)

        dl.state.push(exp.abbreviation)
    })

    qs = `?${params.toString()}`

    if (params) {
        history.replaceState('', '', `?${params.toString()}`);

        // Push params to datalayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'search_filter',
            'searchFilterParams': dl
        });

    } else {
        history.replaceState('', '', location.pathname);
    }
}



/**
 * 
 * Update the search input text when new items are selected
 * @param {string} type The type of the input field we're updating ("expertises" or "locations")
 * 
 */
const updateSearchInputText = (chips, type) => {
    if (debug) console.log('fn: updatesearchinputtext')
    let searchInputText = ``
    let searchInputTextCities = ``

    if (type === 'expertises') {
        // Get the profession and then a comma-separated list of specialties
        let inputExpertises = selectedExpertises
        inputExpertises.forEach((exp, index) => {
            if (index === 0) {
                searchInputText += `${exp.professionText}: ${exp.expertiseText}`
                // searchInputText += `${exp.professionText}`
            } else {
                searchInputText += `, ${exp.expertiseText}`
            }
        })
    } else {
        // Get a comma-separated string of state locations
        let inputStates = selectedStates
        inputStates.forEach((exp, index) => {
            if (index === 0) {
                searchInputText += `${exp.name}`    
            } else {
                searchInputText += `, ${exp.name}`
            }
        })
    }

    // Set some defaults
    if (type === 'locations') {
        locationWrapper.querySelector('.select-btn--container .search-placeholder').innerText = (searchInputText !== '') ? searchInputText : 'Select Locations'
    } else {
        specialtyWrapper.querySelector('.select-btn--container .search-placeholder').innerText = (searchInputText !== '') ? searchInputText : 'Select Specialties by Profession'
    }
}



/**
 * 
 * Add specialty chips based on the selectedXXX arrays
 * 
 */
const addChips = () => {
    if (debug) console.log('fn: addchips', selectedExpertises)
    let chipsMarkup = ``;
    let selectedLength = selectedExpertises.length;
    let count = 0;

    // Loop through our global selectedExpertises array and display a chip
    // But only if the count is three or less
    selectedExpertises.forEach((selection) => {
        if (count <= 2) {
            // chipsMarkup += `<span class="chip" data-expertisecode="${selection.expertiseCode}" data-professioncode="${selection.professionCode}" data-professiontext="${selection.professionText}" data-expertisetext="${selection.expertiseText}">${selection.professionText} <i class="delete"></i></span>`;
            chipsMarkup += `<span class="chip" data-expertisecode="${selection.expertiseCode}" data-professioncode="${selection.professionCode}" data-professiontext="${selection.professionText}" data-expertisetext="${selection.expertiseText}">${selection.expertiseText} <i class="delete"></i></span>`;
        }
        count++;
    })

    // Display the chip count
    totalChipsCount = count
    if (count > 0) {
        mobileSpecialtyChipCountContainer.classList.remove('hide-el')
        mobileSpecialtyChipCountContainer.querySelector('.chip-count').innerHTML = totalChipsCount
    } else {
        mobileSpecialtyChipCountContainer.classList.add('hide-el')
    }

    // We don't want to display too many chips
    // Anything more than three and just have a string display
    additionalChipsCount = (count > 3) ? (count - 3) : 0;
    if (additionalChipsCount > 0) {
        additionalChipsCountText = `<span class="chip--more">+ ${additionalChipsCount} more</span>`
    } else {
        additionalChipsCountText = '';
    }
    chipsSpecialtyContainer.innerHTML = `${chipsMarkup + additionalChipsCountText}`

    // Bind a click even to each chip so they can be removed
    let chips = document.querySelectorAll('.chip');
    chips.forEach((chip) => {
        chip.addEventListener('click', function (e) {
            e.preventDefault()
            removeChip(chip)
        })
    })

    // Adjust the active menu on mobile so it fills the height of the device
    if (window.matchMedia('screen and (max-width: 767px)').matches) {
        if (document.getElementById('specialtyListContainer').querySelector('.chips--container')) {
            let inputHeight = document.getElementById('specialtyListContainer').querySelector('.chips--container').offsetHeight
            inputHeight += offsetHeightForNav
            if (CSS.supports(`( max-height: calc(100dvh - ${inputHeight}px) )`)) {
                specialtyOptions.style.maxHeight = `calc(100dvh - ${inputHeight}px)`
            } else {
                specialtyOptions.style.maxHeight = `calc(100vvh - ${inputHeight}px)`
            }
            
        }
    }

    // The serach page gets it's input value updated after chips are updated
    if (searchPage) {
        updateSearchInputText(chips, 'expertises')
    }
}



/**
 * 
 * Add location chips based on the selectedXXX arrays
 * 
 */
const addLocationChips = () => {
    if (debug) console.log('fn: addlocationchips')
    let chipsMarkup = ``;
    let count = 0;

    // Merge the two separate location arrays
    let mergedLocations = [...selectedStates, ...selectedCities]

    // Display up to three chips
    mergedLocations.forEach((selection) => {
        if (count <= 2) {
            if (selection.type === 'state') {
                chipsMarkup += `<span class="chip chip--location" data-statecode="${selection.code}" data-locationname="${selection.name}">${selection.name} <i class="delete"></i></span>`;
            } else {
                chipsMarkup += `<span class="chip chip--location" data-state="${selection.state}" data-city="${selection.city}" data-locationname="${selection.city}">${selection.city} <i class="delete"></i></span>`;
            }
        }
        count++;
    })

    // Update the chip count
    totalLocationChipsCount = count
    if (count > 0) {
        mobileLocationChipCountContainer.classList.remove('hide-el')
        mobileLocationChipCountContainer.querySelector('.chip-count').innerHTML = totalLocationChipsCount
    } else {
        mobileLocationChipCountContainer.classList.add('hide-el')
    }

    // For more than three chips, display a string
    additionalLocationChipsCount = (count > 3) ? (count - 3) : 0;
    if (additionalLocationChipsCount > 0) {
        additionalLocationChipsCountText = `<span class="chip--more">+ ${additionalLocationChipsCount} more</span>`
    } else {
        additionalLocationChipsCountText = '';
    }
    chipsLocationContainer.innerHTML = `${chipsMarkup + additionalLocationChipsCountText}`

    // Bind a click even to the chip so it can be removed
    let chips = document.getElementById('locationWrapper').querySelectorAll('.chip');
    chips.forEach((chip) => {
        chip.addEventListener('click', function (e) {
            e.preventDefault()      
            removeLocationChip(chip)
        })
    })

    // Adjust the active menu's content's height on mobile
    if (window.matchMedia('screen and (max-width: 767px)').matches) {
        if (document.getElementById('locationListContainer').querySelector('.chips--container')) {
            let inputHeight = document.getElementById('locationListContainer').querySelector('.chips--container').offsetHeight
            inputHeight += offsetHeightForNav
            if (CSS.supports(`( max-height: calc(100dvh - ${inputHeight}px) )`)) {
                locationsOptions.style.maxHeight = `calc(100dvh - ${inputHeight}px)`
            } else {
                locationsOptions.style.maxHeight = `calc(100vh - ${inputHeight}px)`
            }
        }
    }

    // On search page we want to display the chip values in the input
    if (searchPage) {
        updateSearchInputText(chips, 'locations')
    }
}



/**
 * 
 * De/select all states
 * 
 */
const toggleAllStates = () => {
    if (debug) console.log('fn: toggleallstates')
    let allStateEl = document.querySelector('.state--all')
    let states = document.querySelectorAll('.state')
    allStateEl.classList.toggle('checked')
    locationsInput.value = ''
    
    states.forEach((s) => {
        let thisSelected = {}
        thisSelected.name = s.dataset.name
        thisSelected.code = s.dataset.code
        thisSelected.abbreviation = s.dataset.abbreviation
        thisSelected.type = 'state'
        if (allStateEl.classList.contains('checked')) {
            s.classList.add('checked')
            selectedStates.push(thisSelected)
        } else {
            s.classList.remove('checked')
            selectedStates = selectedStates.filter(obj => {
                return s.dataset.code !== obj.code;
            });
        }

        let unique = [];
        selectedStates.map(x => unique.filter(a => a.name == x.name && a.code == x.code && a.type == x.type).length > 0 ? null : unique.push(x));

        selectedStates = unique
    })

    addLocationChips()
}





const groupBy = (array, property) => {
    return array.reduce(function (acc, obj) {
        let key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}




/**
 * 
 * Do stuff after data is fetched from API
 * We want to build out meaningful objects that can be looped through to build dropdowns
 * 
 */
// fetchData().then(([jobLookups, professionsWithTypes]) => {
fetchData().then(([jobLookups]) => {
    if (debug) console.log('fn: fetchdata.then')
    // const types = jobLookups.professionTypes;
    // const types = professionsWithTypes;
    const types = professionTypes
    const expertises = jobLookups.expertises;
    const professions = jobLookups.professions; 
    const states = jobLookups.perDiemMarkets

    

    let locations = states;
    locations.forEach((market) => {
      if (market.state === null) {
        if (
          market.pdMarket === "San Bernardino" ||
          market.pdMarket === "LA Float Pool"
        ) {
          market.state = "California";
        } else {
          market.state = market.pdMarket;
        }
      }
    });
    
    locations = groupBy(locations, "state");
    locations = Object.entries(locations);
    locations = locations.sort();

  


    let objectArrayExpertises = [];
    let objectArrayProfessions = [];
    let finalObj = {};
    let finalObjProfession = {}

    // Get all of the professions
    professions.map((profession) => {
        let obj = {}
        obj.professionCode = profession.id
        obj.professionText = profession.name
        obj.isProfession = true

        for (let index = 0; index < types.length; index++) {
            // if (types[index].id === profession.typeId) {
                if (types[index].id === profession.id) {
                // obj.type = types[index].name;
                obj.type = types[index].professionTypeName;
                break;
            }
        }
        // obj.type = profession.typeId

        if (profession.typeId === 1 || profession.typeId === 2 || profession.typeId === 3) {
            finalObjProfession = obj
            objectArrayProfessions.push(finalObjProfession)
        }
    })

    if (debug) console.log('var: objectArrayProfessions', objectArrayProfessions)

    // Get all of the expertises
    expertises.map((expertise) => {
        let professionExpertiseCodes = expertise.professionExpertiseCodes;

        professionExpertiseCodes.map((code) => {
            let obj = {};
            obj.professionCode = code;
            obj.expertiseCode = expertise.id;
            obj.expertiseText = expertise.name;
            obj.isProfession = false

            for (let index = 0; index < professions.length; index++) {
                if (professions[index].id === code) {
                    obj.professionText = professions[index].name;
                    break;
                }
            }

            for (let index = 0; index < types.length; index++) {
                if (types[index].id === code) {
                    // obj.type = types[index].name;
                    obj.type = types[index].professionTypeName;
                    break;
                }
            }

            if (obj.type !== 'Locum Tenens') {
                finalObj = obj;
                objectArrayExpertises.push(finalObj)
            }
        })
    })

    if (debug) console.log('var: objectArrayExpertises', objectArrayExpertises)

    /**
     * 
     * Reset the professions/specialties dropdown values to initial state
     * 
     */
    reset = () => {     
        if (debug) console.log('fn: reset')   
        specialtyOptions.innerHTML = menuLevel1
        specialtyOptions.className = 'options'
        let typeEls = document.querySelectorAll('.header--default');
        typeEls.forEach((f) => {
            f.addEventListener('click', function(e) {
                e.preventDefault()  
                handleTypeClick(f.textContent)
            })
        })
    }



    /**
     * 
     * Reset the locations dropdown values to initial state
     * 
     */
    resetLocations = () => {
        if (debug) console.log('fn: resetlocations')

        buildLocations()

    }

    reset();



   

    /**
     * 
     * If you build it they will come
     * Loop through all of our fetched data and build out the specialties menu
     * @param {array} arr holds the array of specialties
     * @param {string} level determines which "level" of the menu we're displaying
     * 
     */
    const build = (arr, level, thisType) => {
        if (debug) console.log('fn: build', arr)
        // Array of all professions
        let allProfessions = arr.filter((i) => i.isProfession); 
        if (debug) console.log('allProfessions', allProfessions)
        // Array of all expertises
        let allExpertises = arr.filter((i) => !i.isProfession); 
        if (debug) console.log('allExpertises', allExpertises)
        // Array of all professions with no expertises
        let professionsWithNoExpertise = allProfessions.filter((i) => !allExpertises.find((b) => b.professionText === i.professionText)); 
        if (debug) console.log('professionsWithNoExpertise', professionsWithNoExpertise)
        // Array of all expertises without a profession
        let expertisesWithNoProfession = allExpertises.filter(({ professionCode: id1 }) => !allProfessions.some(({ professionCode: id2 }) => id2 === id1)); 
        if (debug) console.log('expertisesWithNoProfession', expertisesWithNoProfession)
        // Array of all professions that need to be created off of expertises that don't have a profession in the results
        let additionalProfessions = expertisesWithNoProfession.map(({ expertiseCode, expertiseText, ...rest }) => { return rest; }); 
        if (debug) console.log('additionalProfessions', additionalProfessions)
        // New array with ALL the professions needed
        let mergedArray = [...allProfessions, ...additionalProfessions];
        if (debug) console.log('mergedArray', mergedArray)
        // Set of types sorted
        let allTypes = new Set(...[mergedArray.map((a) => a.type).sort()])
        // allTypes.delete(undefined)
        // let allTypesFiltered = allTypes.filter(a => a !== undefined);

        if (debug) console.log('allTypes', allTypes)

        let template = ``
        if (level === '1') {
            if (!isSearch) {
                template += `<a href="#" style="" class="back-to back-to--types" onclick="reset(); return false;">Back to Profession Type</a>`;
            } else {
                template += `<a href="#" style="" class="back-to back-to--types" onclick="showSearchResults(); return false;">Back to search</a>`;
            }
            specialtyOptions.className = 'options options--professions'
        }
        if (level === '2') {
            if (!isSearch) {
                template += `<a href="#" style="" class="back-to back-to--types" onclick="handleBackToProfessionClick('${currClicked.type}'); return false;">Back to ${currClicked.type} Professions</a>`;
            } else {
                template += `<a href="#" style="" class="back-to back-to--types" onclick="showSearchResults(); return false;">Back to search</a>`;
            }
            specialtyOptions.className = 'options options--expertises'
        }

        allTypes.forEach((type) => {
            
            // Expertises under each type
            let expertises = allExpertises.filter((b) => b.type === type)
            // Expertises grouped by each profession
            let professions = expertises.reduce((obj, expertise) => ({ ...obj, [expertise['professionText']]: (obj[expertise['professionText']] || []).concat(expertise) }), {})
            
            if (debug) console.log('professions', professions)

            // Add profs with no expertise
            professionsWithNoExpertise
                .filter((ne) => ne.type === type)
                .forEach((ne) => {
                    professions[ne.professionText] = [{ type: ne.type, professionText: ne.professionText, professionCode: ne.professionCode }]
                })

            // Construct template
            Object.keys(professions).forEach((profession) => {


                // if (professions[profession][0].type !== undefined) {

                    template += `
                        <li class="parent">
                            <span class="header">${professions[profession][0].type}</span>
                            <ul><li><a href="#" class="profession" data-professiontext="${professions[profession][0].professionText}" data-professioncode="${professions[profession][0].professionCode}">${professions[profession][0].professionText}</a><ul>
                                <li><a href="#" class="expertise--all" data-professioncode="${professions[profession][0].professionCode}">All ${professions[profession][0].professionText} Specialties</a></li>
                        `
                    // List each expertise for the profession
                    professions[profession].forEach((expertise) => {
                        if (expertise.expertiseText) {
                            let thisObject = {}
                            thisObject.professionCode = expertise.professionCode.toString()
                            thisObject.expertiseCode = expertise.expertiseCode.toString()

                            const isFound = selectedExpertises.some(element => {
                                if (element.professionCode === expertise.professionCode.toString() && element.expertiseCode === expertise.expertiseCode.toString()) {
                                return true;
                                }
                                return false;
                            });

                            template += `<li><a href="#" class="expertise ${isFound ? 'checked' : ''}" data-professioncode="${expertise.professionCode}" data-expertisecode="${expertise.expertiseCode}" data-expertisetext="${expertise.expertiseText}" data-professiontext="${expertise.professionText}" data-professiontype="${professions[profession][0].type}">${expertise.expertiseText}</a></li>`
                        }
                    })

                    template += `</ul></li></ul></li>`


                // }


            })
        })

        specialtyOptions.innerHTML = arr.length > 0 ? template : `<span class="no-matches" style="">No matches</span>`;

        let expertiseEls = document.querySelectorAll('.expertise');
        expertiseEls.forEach((f) => {
            f.addEventListener('click', function (e) {
                e.preventDefault()
                
                specialtyInput.value = ''
                f.classList.toggle('checked')
                let thisSelected = {}
                thisSelected.professionCode = f.dataset.professioncode
                thisSelected.expertiseCode = f.dataset.expertisecode
                thisSelected.professionText = f.dataset.professiontext
                thisSelected.expertiseText = f.dataset.expertisetext
                thisSelected.professionType = f.dataset.professiontype

                if (f.classList.contains('checked')) {                    
                    if (selectedExpertises.length > 0) {
                        if (selectedExpertises[0].professionCode !== thisSelected.professionCode) {
                            selectedExpertises = []
                        }
                    }
                    selectedExpertises.push(thisSelected)

                    let expertises = document.querySelectorAll('.expertise.checked');
                    expertises.forEach((exp) => {
                        if (exp.dataset.professioncode !== thisSelected.professionCode ) {
                            exp.classList.remove('checked')
                        }
                    })
                } else {
                    selectedExpertises = selectedExpertises.filter(obj => {
                        return f.dataset.expertisecode !== obj.expertiseCode;
                    });
                }

                addChips()
            })

        })

        let professionEls = document.querySelectorAll('.profession');
        professionEls.forEach((f) => {
            f.addEventListener('click', function (e) {
                e.preventDefault()
                handleProfessionClick(f.dataset.professioncode, f.dataset.professiontext)
            })
        })

      

        let allExpertiseEl = document.querySelector('.expertise--all');
        if (allExpertiseEl) {
            allExpertiseEl.addEventListener('click', function(e) {
                e.preventDefault()
                specialtyInput.value = ''
                let thisExpertiseEls = document.querySelectorAll('.expertise');
                let isChecked;
                allExpertiseEl.classList.toggle('checked')
                if (allExpertiseEl.classList.contains('checked')) {
                    isChecked = true;
                } else {
                    isChecked = false;
                }
                thisExpertiseEls.forEach((f) => {
                    if (isChecked) {
                        f.classList.add('checked')
                    } else {
                        f.classList.remove('checked')
                    }
                    let thisSelected = {}
                    thisSelected.professionCode = f.dataset.professioncode
                    thisSelected.expertiseCode = f.dataset.expertisecode
                    thisSelected.professionText = f.dataset.professiontext
                    thisSelected.expertiseText = f.dataset.expertisetext
                    thisSelected.professionType = f.dataset.professiontype

                    if (f.classList.contains('checked')) {                    
                        if (selectedExpertises.length > 0) {
                            if (selectedExpertises[0].professionCode !== thisSelected.professionCode) {
                                selectedExpertises = []
                            }
                        }
                        selectedExpertises.push(thisSelected)

                        let expertises = document.querySelectorAll('.expertise.checked');
                        expertises.forEach((exp) => {
                            if (exp.dataset.professioncode !== thisSelected.professionCode ) {
                                exp.classList.remove('checked')
                            }
                        })
                    } else {
                        selectedExpertises = selectedExpertises.filter(obj => {
                            return f.dataset.expertisecode !== obj.expertiseCode;
                        });
                    }

                    let unique = [];
                    selectedExpertises.map(x => unique.filter(a => a.expertiseCode == x.expertiseCode && a.expertiseText == x.expertiseText && a.professionCode == x.professionCode && a.professionText == x.professionText).length > 0 ? null : unique.push(x));

                    selectedExpertises = unique
                    
                    addChips()
                })
            })
        }
    }

    
    
    /**
     * 
     * Construct and build the professions based on the profession type clicked
     * @param {string} type 
     * 
     */
    const handleTypeClick = (type) => {
        
        isSearch = false;
        specialtyListContainer.className = ''
        // console.log('objectArrayProfessions', objectArrayProfessions)
        let professionData = objectArrayProfessions.filter(value => {
            const professionMatches = value.type === type
            return professionMatches;
        });
        currClicked.type = type
        build(professionData, '1');
    }


    
    /**
     * 
     * Construct and build the professions based on the profession type clicked
     * @param {string} professionCode is the numerical value of the profession
     * @param {string} professionText is the string version of the profession used for display
     * 
     */
    handleProfessionClick = (professionCode, professionText) => {
        if (debug) console.log('fn: handleprofclick')
        let expertiseData = objectArrayExpertises.filter(value => {
            const expertiseMatches = value.professionCode === parseInt(professionCode)
            return expertiseMatches;
        });
        currClicked.profession = professionCode
        currClicked.professionText = professionText
        build(expertiseData, '2');
    }



    /**
     * 
     * Construct and build the professions based on the profession type clicked (determined by the back link)
     * @param {string} type 
     * 
     */
    handleBackToProfessionClick = (type) => {
        if (debug) console.log('fn: handlebacktoprofclick')
        let professionData = objectArrayProfessions.filter(value => {
            const professionMatches = value.type === type
            return professionMatches;
        });
        build(professionData, '1');  
    }



    /**
     * 
     * Displays search results from user input and rebuilds the menu
     * 
     */
    showSearchResults = () => {
        if (debug) console.log('fn: showsearchresults')
        build(searchResults)
        specialtyOptions.className = 'options options--search'
    }



    /**
     * 
     * Helper function to sort location results in type-ahead order
     * So typing "den" will return "Denver" before "Bradenton" regardless of alpha sort
     * @param {array} data The array we're sorting
     * @param {string} term The string we're sorting against
     * 
     */
    var _sortByTerm = function (data, term) {
        return data.sort(function (a, b) {
           return a['city'].indexOf(term) < b['city'].indexOf(term) ? -1 : 1;
        });
    };



    /**
     * 
     * Displays search results from user input and rebuilds the menu
     * 
     */
    const handleLocationSearch = () => {
        if (debug) console.log('fn: handlelocationclick')
        isLocationSearch = true;
        locationListContainer.className = 'search-results'
        const searchStr = locationsInput.value.trim().toLowerCase();

        specialtyOptions.className = 'options options--search'

        if (searchStr === '') {
           
        } 

        // document.getElementById('locationListContainer').querySelectorAll('.parent li').classList.remove('hide-el')

        let list = document.getElementById('locationListContainer').querySelectorAll('.options .parent a');
        list.forEach((l) => {
            if(l.dataset.name.toLowerCase().includes(searchStr) || l.dataset.parent.toLowerCase().includes(searchStr)) {
                l.parentElement.classList.remove('hide-el')
                if (l.parentElement.classList.contains('child-market')) {
                    l.parentElement.parentElement.parentElement.classList.remove('hide-el')
                }
            } else {
                l.parentElement.classList.add('hide-el')
                if (l.parentElement.classList.contains('child-market')) {
                    // l.parentElement.parentElement.parentElement.classList.add('hide-el')
                }
            }
        })

        checkListClasses = Array.from(list)
        let noMatches = checkListClasses.every(item => item.parentElement.classList.contains('hide-el'))
        if (noMatches) {
            locationsOptions.querySelector('.no-matches').classList.remove('hide-el')
        } else {
            locationsOptions.querySelector('.no-matches').classList.add('hide-el')
        }
    }



    /**
     * 
     * Displays search results from user input and rebuilds the menu
     * 
     */
    const handleSearch = () => {
        if (debug) console.log('fn: handlesearch')
        isSearch = true;
        specialtyListContainer.className = 'search-results'
        const searchStr = specialtyInput.value.trim().toLowerCase();

        specialtyOptions.className = 'options options--search'

        if (searchStr === '') {
            reset()
            return;
        }

        let expertiseData = objectArrayExpertises.filter(value => {
            const expertiseMatches = value.expertiseText.toLowerCase().includes(searchStr);
            return expertiseMatches;
        });

        let professionData = objectArrayProfessions.filter(value => {
            const professionMatches = value.professionText.toLowerCase().includes(searchStr);
            return professionMatches;
        });

        let array3 = [...professionData, ...expertiseData];
        // let array3 = [...professionData];
        array3 = [...new Set(array3)];

        searchResults = array3
        // console.log('array3', array3)
        build(array3);
    }


    specialtyInput.addEventListener("input", handleSearch);
    locationsInput.addEventListener("input", handleLocationSearch);



    /**
     * 
     * If you build it they will come
     * Loop through all of our fetched data and build out the locations menu
     * @param {array} states holds the array of states
     * @param {array} cities holds the array of cities
     * 
     */
    const buildLocations = (states, cities) => {     
        if (debug) console.log('fn: buildlocations')
        let isSearch = false
        if (locationsInput.value.trim() !== '') {
            isSearch = true
        }

        
        





        let template = ``
        template += `<li class="parent"><ul>`
        locations.forEach((location) => {
            let childIds = []
            if (location[1].length > 1 || (location[1].length == 1 && location[1][0].pdMarket !== location[1][0].state)) {
                // if (location[1].length > 1) {
                location[1].forEach((l) => {
                    childIds.push(l.id)
                })
            }

            if (location[1].length == 1 && (location[1][0].pdMarket == location[1][0].state)) {
                // console.log(location[1][0].state)
                // submarkets do not exist
                // template += `<li><a href="#" class="state" data-name="${location[1][0].pdMarket}" data-parent="${location[1][0].state}" data-code="${childIds.join(',')}">${location[1][0].state}</a></li>`
                template += `<li><a href="#" class="state" data-name="${location[1][0].pdMarket.trim()}" data-parent="${location[1][0].state.trim()}" data-code="${location[1][0].id}">${location[1][0].state}</a></li>`
            } else {
                // submarkets exist
                template += `<li><a href="#" class="state" data-name="${location[1][0].state.trim()}" data-parent="${location[1][0].state.trim()}" data-code="${childIds.join(',')}">${location[1][0].state}</a>`
                template += `<ul>`
                location[1].forEach((l) => {
                    template += `<li class="child-market"><a href="#" class="state" data-name="${l.pdMarket.trim()}" data-parent="${l.state.trim()}" data-code="${l.id}">&mdash; ${l.pdMarket}</a></li>`
                })
                template += `</ul></li>`
            }

            
        })

        template += `</ul><span class="no-matches hide-el" style="">No matches</span></li>`







        

        locationsOptions.innerHTML = template
        // locationsOptions.innerHTML += citiesMarkup
        
        let stateEls = document.getElementById('locationListContainer').querySelectorAll('.state');

        stateEls.forEach((f) => {
            f.addEventListener('click', function (e) {
                e.preventDefault()
                
                // locationsInput.value = ''
                f.classList.toggle('checked')
                let thisSelected = {}
                thisSelected.name = f.dataset.name
                thisSelected.code = f.dataset.code
                thisSelected.abbreviation = f.dataset.abbreviation
                thisSelected.type = 'state'

                if (f.classList.contains('checked')) {                    
                    selectedStates.push(thisSelected)
                } else {
                    selectedStates = selectedStates.filter(obj => {
                        return f.dataset.code !== obj.code;
                    });
                }
                
                addLocationChips()
            })
        })

    }

        buildLocations(states)  
    // }


    let fullArr = [...objectArrayProfessions, ...objectArrayExpertises];
    fullArr = [...new Set(fullArr)];
    window.localStorage.setItem('key',JSON.stringify(fullArr)); 

   

    /**
     * 
     * Helper function that checks if an object is empty
     * @param {object} obj we're checking the contents of
     * @return {boolean}
     * 
     */
    const isEmptyObject = (obj) => {
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    }



    /**
     * 
     * Gets the current URL's parameters
     * @param {string} url current URL
     * @return {object} params containing an object of parameters
     * 
     */
    const getParams = (url = window.location) => {
        let params = {};
        new URL(url).searchParams.forEach(function (val, key) {
            if (params[key] !== undefined) {
                if (!Array.isArray(params[key])) {
                    params[key] = [params[key]];
                }
                params[key].push(val);
            } else {
                params[key] = val;
            }
        });
        return params;
    }



    /**
     * 
     * Updates the expertise selections
     * 
     */
    const updateSelections = () => { 
        if (debug) console.log('fn: updateselections')
        selectedExpertises.forEach((e) => {
            let el = document.querySelector(`#specialtyListContainer .expertise[data-expertisecode="${e.expertiseCode}"]`)
            el.click()
        })
    }



    /**
     * 
     * Based on the selected values, builds a formatted search query
     * This constructs the API endpoing URL we'll make a call to
     * 
     */
    const buildSearchQuery = () => {
        if (debug) console.log('fn: buildsearchquery')
        let searchProfession
        if (selectedExpertises.length > 0) {
            searchProfession = `professionId=${selectedExpertises[0].professionCode}`;
        } else {
            searchProfession = ``
        }
        
        let searchExpertise = ``;
        selectedExpertises.forEach((e) => {
            searchExpertise += `&expertiseId=${e.expertiseCode}`
        })
        let searchStates = ``;

        if (debug) console.log('var: selectedStates', selectedStates)


        selectedStates.forEach((e) => {
            if (Number.isInteger(Number(e)) && Number(e) > 0) {
                searchStates += `&PerdiemMarketId=${e.code}`
            } else {
                let codeArr = e.code.split(',');
                codeArr.forEach((c) => {
                    searchStates += `&PerdiemMarketId=${c}`
                })
            }
        })
        // let searchCities = ``;
        // selectedCities.forEach((e) => {
        //     searchCities += `&cityStateCodes=${encodeURIComponent(e.city)}`
        // })

        //https://api.ayahealthcare.com/Shifts/Jobs?pageSize=2000&professionId=942&expertiseId=1236&PerdiemMarketId=152
        apiUrl = `https://${coreApi}.ayahealthcare.com/Shifts/Jobs?${searchProfession}${searchExpertise}${searchStates}&pageSize=${resultsLimit}`
        if (debug) console.log('var: apiurl', apiUrl)
        
    }




    /**
     * 
     * We're on the search results page (not home page)
     * 
     */
    if (searchPage) {
    

        // push to datalayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'plp_view'
        });
        
        // Get the selected values from the URL if they exist and update our selections
        let params = getParams();
        if (!isEmptyObject(params)) {
            if (debug) console.log('status: page load params exist', params)
            let currProfession = params.profession
            
            if (currProfession) {
                let currSelections = fullArr.filter(el => (el.isProfession !== true))
                if (params.specialty) {
                    params.specialty = typeof params.specialty === 'string' ? [params.specialty] : params.specialty;
                    if (params.specialty.includes('0') ) {   
                        currSelections = currSelections.filter(el => (el.professionCode.toString() === currProfession ))  
                        selectedExpertises = currSelections  
                    } else {
                        params.specialty = typeof params.specialty === 'string' ? [params.specialty] : params.specialty;
                        currSelections = currSelections.filter(el => (el.professionCode.toString() === currProfession && params.specialty.includes(el.expertiseCode.toString())))
                        selectedExpertises = currSelections
                    }
                } else {
                    currSelections = currSelections.filter(el => (el.professionCode.toString() === currProfession ))
                    selectedExpertises = currSelections
                }
                
                let expertiseData = objectArrayExpertises.filter(value => {
                    const expertiseMatches = value.professionCode === parseInt(currProfession)
                    return expertiseMatches;
                });


                currClicked.type = expertiseData[0].type
                currClicked.profession = expertiseData[0].professionCode
                currClicked.professionText = expertiseData[0].professionText
                build(expertiseData, '2');
                updateSelections()
            } else {
                reset()
            }

            if (params.state) {
                params.state = typeof params.state === 'string' ? [params.state] : params.state;
                // let currStateSelections = states.filter(el => (params.state.indexOf(el.toString()) >= 0))
                if (debug) console.log('currStateSelections', params.state)
                params.state.forEach((e) => {
                    let el = document.querySelector(`#locationListContainer .state[data-name="${e}"]`)
                    el.click()
                })    
            }
            
  

            buildSearchQuery()
            renderResults()

        } else {
            if (debug) console.log('status: page load params do not exist', params)
            buildSearchQuery()
            renderResults()
        }


        /**
         * 
         * Checks if the image exists 
         * @param {string} url CDN URL
         * @return {boolean}
         * 
         */
        const checkImageExists = (imageUrl) => {
            return new Promise((resolve, reject) => {
              let imageData = new Image();
          
              imageData.onload = function () {
                  resolve(true);
              };
              imageData.onerror = function () {
                  reject(false);
              };
          
              imageData.src = imageUrl;
            });
          }



        /**
         * 
         * Render the deets for the currently selected job
         * @param {integer} id Job ID
         * 
         */
        async function renderJobDetails(id, isFirst) {
            if (debug) console.log('fn: renderjobdetails')

            await getJobDetails(id)

            // Defines the messaging depending on employmentType
            let jobOutro = `We'll work with you to build the healthcare career of your dreams. Whether you want a job close to home or across the country, we've got you.`
            if (jobDetailData.employmentTypeText === 'LocumTenens1099' || jobDetailData.employmentTypeText === 'LocumTenensW2') {
                jobOutro = `We'll take care of everything so you can focus on what you do best - providing exceptional patient care!`
            }

            // Build out the experiences
            let experienceArr = []
            if (jobDetailData.isBsnRequired || jobDetailData.requiredCertifications || jobDetailData.requiredSkills) {
                if (jobDetailData.isBsnRequired) {
                    experienceArr.push(['Degree: BSN'])
                }

                if (jobDetailData.requiredCertifications.length > 0) {
                    let certs = 'Certifications: ' + jobDetailData.requiredCertifications.join(', ')
                    experienceArr.push([certs])
                }

                if (jobDetailData.requiredSkills.length > 0) {
                    let skills = 'Skills: ' + jobDetailData.requiredSkills.join(', ')
                    experienceArr.push([skills])
                }
            }
        
            // Build out the markup for the job and show it
            jobDetailsContainer.classList.remove('hide-el')

           
            let transparentPay = `${jobDetailData.shiftRate > 0 ? `$${jobDetailData.shiftRate.toFixed(0)} / ${jobDetailData.hours} hr` : ''}`;




            let fullLocation = ``;
            if (!jobDetailData.city && jobDetailData.employmentTypeText == 'WorkforceDisruption') {
                fullLocation = jobDetailData.stateAbbrev;
            } else if (!jobDetailData.city) {
                fullLocation = 'Various Cities, ' + jobDetailData.stateAbbrev;
            } else {
                fullLocation = jobDetailData.city + ', ' + jobDetailData.stateAbbrev
            }

            let cardTitle = `PRN `
            let externalH1 = `PRN `
            if (jobDetailData.employmentTypeText == 'TravelOrContract' || jobDetailData.employmentTypeText == 'Travel/Contract') {
                cardTitle += `Travel `
                externalH1 += `Travel `
            }
            cardTitle += jobDetailData.expertiseText + ` ` + jobDetailData.professionText + ` job in ` + fullLocation + ` - ` + transparentPay
            externalH1 += jobDetailData.expertiseText + ` ` + jobDetailData.professionText

            let startDate = new Date(jobDetailData.startDate);





            let singleJobMarkup = ``
            singleJobMarkup += `
            <style>
            .job-details .job-img:before {
                background: url(${cdnUrl}) no-repeat 50%;
                background-size: cover;
                content: "";
                height: 250px;
                position: absolute;
                width: 100%;
            </style>
            <div class="_job-details_">
                <div id="job-details--header">
                    <span>Job Details</span>
                    <span id="close">CLOSE</span>
                </div>
                <h3>${fullLocation}</h3>
                <div class="job-title">
                    <h1>${cardTitle}</h1>
                    <div class="info">
                        <span>Job ID: ${jobDetailData.jobID}</span> | 
                        <span>Job Type: PRN</span>
                    </div>
                </div>
                <div class="job-img"></div>
                <div class="details">
                    <h3>Job Details</h3>
                    <ul class="job">
                        <li class="ico ico-profession"><strong>Profession:</strong>&nbsp;${jobDetailData.professionText}</li>
                        ${jobDetailData.shiftRate > 0 ?
                        `<li class="ico ico-pay"><strong>Pay:</strong>&nbsp;${transparentPay}</li>`
                        : ''}
                        <li class="ico ico-length"><strong>Assignment Length:</strong>&nbsp;${jobDetailData.duration} weeks</li>
                        <li class="ico ico-schedule"><strong>Schedule:</strong>&nbsp;${jobDetailData.shifts}, ${jobDetailData.hours}-hour ${jobDetailData.shiftTime}</li>
                        ${jobDetailData.positions !== 0 ?
                        `<li class="ico ico-openings"><strong>Openings:</strong>&nbsp;${jobDetailData.positions}</li>`
                        : ''}
                        <li class="ico ico-start"><strong>Orientation Date:</strong>&nbsp;${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}</li>
                        <li class="ico ico-facility"><strong>Facility Info:</strong>&nbsp;<a href="https://${myAyaUrl}.ayahealthcare.com/jobs/${jobDetailData.jobID}">Log in to view pay details</a></li>
                    </ul>
                    <p class="mb-4">Looking for a flexible schedule and fulfilling healthcare career? With Shifts, you have the freedom to work when and where you want.</p>
                </div>
            </div>`

            document.getElementById('innerjobdetails').innerHTML = singleJobMarkup

            document.querySelector('.with-shifts').classList.remove('hide-el')

          

            if (window.matchMedia('screen and (max-width: 767px)').matches) {
                document.querySelector('html').classList.add('is-clipped')
            }

            // Populate the form hidden input with the jobID
            document.getElementById('jobId').value = jobDetailData.jobID

            // Add current job to datalayer
            jobDetailData.transparentPay = jobDetailData.shiftRate.toFixed(0);
            jobDetailData.h1 = externalH1;
            if (!isFirst) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'view_job',
                    'jobDetails': jobDetailData,
                    'firstJobCard': false
                });
            } else {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'view_job',
                    'jobDetails': jobDetailData,
                    'firstJobCard': true
                }); 
            }


            // Bind a click event to the close button
            document.getElementById('close').addEventListener('click', function() {
                if (debug) console.log('event: job close mobile')
                document.getElementById('jobDetails').classList.add('hide-el')
                if (window.matchMedia('screen and (max-width: 767px)').matches) {
                    document.querySelector('html').classList.remove('is-clipped')
                }
            })
        }






        /**
         * 
         * Pagination: previous
         * 
         */
        function previousPage() {
            if (debug) console.log('fn: prevpage')
            document.getElementById('prevButton').classList.add('is-loading')
            currPage--
            offset = (currPage - 1) * resultsLimit
            // offset = (currPage - 1) * jobsPerPage
            initialSearch = false
            renderResults()

            if (window.matchMedia('screen and (min-width: 768px)').matches) {
                var element = document.getElementById('results');
                var headerOffset = document.querySelector('header').offsetHeight;
                var heroDivOffset = document.getElementById('search-menu').offsetHeight;
                var elementPosition = element.getBoundingClientRect().top;
                var resultsCountOffset = document.getElementById('results-count').offsetHeight + 20;
                var offsetPosition = elementPosition + window.pageYOffset - headerOffset - heroDivOffset - resultsCountOffset;
            
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
            
          }
          


        /**
         * 
         * Pagination: next
         * 
         */
        function nextPage() {
            if (debug) console.log('fn: nextpage')
            // push to datalayer
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'plp_next_pagination'
            });

            document.getElementById('nextButton').classList.add('is-loading')
            offset = currPage * resultsLimit
            currPage++
            initialSearch = false
            renderResults()

            if (window.matchMedia('screen and (min-width: 768px)').matches) {
                var element = document.getElementById('results');
                var headerOffset = document.querySelector('header').offsetHeight;
                var heroDivOffset = document.getElementById('search-menu').offsetHeight;
                var elementPosition = element.getBoundingClientRect().top;
                var resultsCountOffset = document.getElementById('results-count').offsetHeight + 20;
                var offsetPosition = elementPosition + window.pageYOffset - headerOffset - heroDivOffset - resultsCountOffset;
            
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }


        /**
         * 
         * Bind click events to the pagination buttons
         * 
         */
        if (document.getElementById('resultsPagination')) {
            if (debug) console.log('pagination buttons found')
            let paginateNextBtn = document.getElementById('nextButton')
            let paginatePrevBtn = document.getElementById('prevButton')
            paginateNextBtn.addEventListener('click', nextPage, false);
            paginatePrevBtn.addEventListener('click', previousPage, false);
        }

        

        /**
         * 
         * Renders the results after getting the job deets
         * 
         */
        async function renderResults(page = 1) {
            if (debug) console.log('fn: renderresults')
            searchLoader.classList.remove('hide-el')

            // if (debug) console.log('JOBDATA', jobsData)
            // if (jobsData.length < 1 || initialSearch) {
                await getData()
            // }

            // If something went wrong and we set the deets to null then get out
            if (jobsData == null) {
                return
            }

            searchLoader.classList.add('hide-el')





            // Show/hide the appropriate content
            if (jobsData == null || !professionTypes) {
                // jobsData = null
                document.getElementById("results-inner-container").innerHTML = ``
                document.getElementById('maintenance').classList.remove('hide-el')
                document.getElementById('no-results').classList.add('hide-el')
                document.getElementById('results-count').classList.add('hide-el')
                document.getElementById('resultsPagination').classList.add('hide-el')
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    document.getElementById('jobDetails').classList.add('hide-el')
                }
                // document.querySelector('.with-shifts').classList.add('hide-el')
            } else if (jobsData.length === 0) {
                document.getElementById('no-results').classList.remove('hide-el')
                document.getElementById('maintenance').classList.add('hide-el')
                document.getElementById('results-count').classList.add('hide-el')
                document.getElementById('resultsPagination').classList.add('hide-el')
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    document.getElementById('jobDetails').classList.add('hide-el')
                }
                // document.querySelector('.with-shifts').classList.add('hide-el')
            } else {
                document.getElementById('no-results').classList.add('hide-el')
                document.getElementById('maintenance').classList.add('hide-el')
                document.getElementById('resultsPagination').classList.remove('hide-el')
                document.getElementById('results-count').classList.remove('hide-el')
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    document.getElementById('jobDetails').classList.remove('hide-el')
                }
                document.getElementById('results-count').innerHTML = `${uniqueJobsCount} Unique Openings`
                // document.querySelector('.with-shifts').classList.remove('hide-el')
            }









        

            /**
             * 
             * Removes the active state of all jobs
             * 
             */
            const removeActiveJob = () => {
                if (debug) console.log('fn: removeactivejob')
                let jobEls = document.querySelectorAll('.job')
                jobEls.forEach((f) => {
                    f.classList.remove('active')
                })
            }


            /**
             * 
             * Pagination
             * 
             */
            let first, last = 0
            prevButton.classList.remove('is-loading')
            nextButton.classList.remove('is-loading')



            // paginationText.innerHTML = ``
            
            // Create html for the paginated cards
            let jobsMarkup = ``;
            
            // let chunkStart = (currPage == 1) ? 0 : (currPage - 1) * jobsPerPage + 1
            // let chunkEnd = chunkStart + jobsPerPage 
            // let jobsChunk = jobsData.slice(chunkStart, chunkEnd);
            


            if (currPage == 1) {
                prevButton.style.visibility = "hidden";
                // first = chunkStart + 1
                first = offset + 1
            } else {
                prevButton.style.visibility = "visible";
                // first = chunkStart
                first = offset + 1
            }
            
            if (currPage == Math.ceil(uniqueJobsCount / resultsLimit)) {
            // if (currPage == Math.ceil(uniqueJobsCount / jobsPerPage)) {
                nextButton.style.visibility = "hidden";
                // last = chunkEnd
                last = uniqueJobsCount
            } else {
                nextButton.style.visibility = "visible";
                last = (offset) + resultsLimit
                // last = chunkEnd
            }



            paginationText.innerHTML = `${first} - ${last} of ${uniqueJobsCount.toLocaleString('en-US')}`

            // if (debug) console.log('pagination from', chunkEnd, currPage)

            // jobsChunk.forEach(job => {
            jobsData.forEach(job => {
                let jobPositionsStr = job.positions === 1 ? `Opening` : `Openings`

                let transparentPay = `${job.shiftRate > 0 ? `$${job.shiftRate.toFixed(0)} / ${job.hours} hr` : ''}`;

                let fullLocation = ``;
                if (!job.city && job.employmentTypeText == 'WorkforceDisruption') {
                    fullLocation = job.stateAbbrev;
                } else if (!job.city) {
                    fullLocation = 'Various Cities, ' + job.stateAbbrev;
                } else {
                    fullLocation = job.city + ', ' + job.stateAbbrev
                }

                let cardTitle = `PRN `
                if (job.employmentTypeText == 'TravelOrContract' || job.employmentTypeText == 'Travel/Contract') {
                    // cardTitle += `Travel `
                }
                cardTitle += job.expertiseText + ` ` + job.professionText + ` job in ` + fullLocation + ` - ` + transparentPay


                let baseUrl = window.location.origin
                let professionSlug = makeSlug(job.professionText);
                let expertiseSlug = makeSlug(job.expertiseText);
                let profExp = (professionSlug == expertiseSlug) ? professionSlug : expertiseSlug + '-' + professionSlug;
                let citySlug = makeSlug(job.city);
                let stateSlug = makeSlug(job.state);


                jobsMarkup += `<div class="job-info job" data-id="${job.jobID}">`
                jobsMarkup += `    <h2><a href="${baseUrl}/job/per-diem-${profExp}-${citySlug}-${stateSlug}/${job.jobID}/" onclick="return false;">${cardTitle}</a></h2>`
                jobsMarkup += `    <ul class="">`
                jobsMarkup += `        <li class="ico ico-title"><strong>${job.expertiseText}</strong></li>`
                jobsMarkup += `        <li class="ico ico-pay">${transparentPay}</li>`
                jobsMarkup += `        <li class="ico ico-schedule">${job.hours}-hour ${job.shiftTime}</li>`
                if (job.positions !== 0) {
                    jobsMarkup += `        <li class="ico ico-openings">${job.positions} ${jobPositionsStr}</li>`
                }
                jobsMarkup += `    </ul>`
                jobsMarkup += `</div>`
                
            });
            document.getElementById("results-inner-container").innerHTML = jobsMarkup;

            let jobEls = document.querySelectorAll('.job');
            
            jobEls.forEach((f) => {
                f.addEventListener('click', function() {
                    removeActiveJob()
                    
                    f.classList.add('active')
                    renderJobDetails(f.dataset.id, false)

                    if (window.matchMedia('screen and (min-width: 768px)').matches) {
                        var element = document.getElementById('results');
                        var headerOffset = document.querySelector('header').offsetHeight;
                        var heroDivOffset = document.getElementById('search-menu').offsetHeight;
                        var elementPosition = element.getBoundingClientRect().top;
                        var resultsCountOffset = document.getElementById('results-count').offsetHeight + 20;
                        var offsetPosition = elementPosition + window.pageYOffset - headerOffset - heroDivOffset - resultsCountOffset;
                    
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth"
                        });
                    }
                })
            })

            // Load the first job from the results
            let firstJob = document.querySelector('.job')
            if (firstJob) {
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    firstJob.classList.add('active')
                    renderJobDetails(firstJob.dataset.id, true)
                    
                }
            } else {
                jobDetailsContainer.classList.add('hide-el')
            }


            if (window.matchMedia('screen and (min-width: 768px)').matches) {
                var element = document.getElementById('results');
                var headerOffset = document.querySelector('header').offsetHeight;
                var elementPosition = element.getBoundingClientRect().top;
                var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
                // window.scrollTo({
                //     top: offsetPosition,
                //     behavior: "smooth"
                // });
            }

            const paginationContainer = document.getElementById("resultsPagination");
            let numPages = Math.ceil(uniqueJobsCount / resultsLimit)
            // let numPages = Math.ceil(uniqueJobsCount / jobsPerPage)
            
            offset = 0
            
        }
        
       
        /**
         * 
         * Get the data!
         * 
         */
        async function getData( ) {
            if (debug) console.log('fn: getdata', `${apiUrl}&Skip=${offset}`)
            // Fetch the data but return null if there's an error
            const response = await fetch(`${apiUrl}&Skip=${offset}`)

            // searchLoader.classList.add('hide-el')

            // const response = await fetch(`${apiUrl}`)
            const jobs = await response.json()
                .catch((error) => {
                    return null
                })

            // searchLoader.classList.remove('hide-el')

            if (debug) console.log('jobs', jobs.data)

            if (jobs != null) {
                uniqueJobsCount = jobs.filtered
                // uniqueJobsCount = jobs.data.length
                jobsData = jobs.data
                // jobsData = jobsData.sort((a, b) => (a.shiftRate < b.shiftRate) ? 1 : (a.shiftRate === b.shiftRate) ? ((a.shiftRate < b.shiftRate) ? 1 : -1) : -1);
                totalJobsCount = jobs.total
                totalJobsCount = totalJobsCount.toLocaleString('en-US')
                // totalJobsCount = uniqueJobsCount
                // totalJobPages = Math.round(totalJobsCount / jobsPerPage)
                // if (debug) console.log('var: totaljobpages', totalJobPages)


                
            }

            // Show/hide the appropriate content
            if (jobs == null || !professionTypes) {
                jobsData = null
                document.getElementById("results-inner-container").innerHTML = ``
                document.getElementById('maintenance').classList.remove('hide-el')
                document.getElementById('no-results').classList.add('hide-el')
                document.getElementById('results-count').classList.add('hide-el')
                document.getElementById('resultsPagination').classList.add('hide-el')
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    document.getElementById('jobDetails').classList.add('hide-el')
                }
                // document.querySelector('.with-shifts').classList.add('hide-el')
            } else if (jobs.count === 0) {
                document.getElementById('no-results').classList.remove('hide-el')
                document.getElementById('maintenance').classList.add('hide-el')
                document.getElementById('results-count').classList.add('hide-el')
                document.getElementById('resultsPagination').classList.add('hide-el')
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    document.getElementById('jobDetails').classList.add('hide-el')
                }
                // document.querySelector('.with-shifts').classList.add('hide-el')
            } else {
                document.getElementById('no-results').classList.add('hide-el')
                document.getElementById('maintenance').classList.add('hide-el')
                document.getElementById('resultsPagination').classList.remove('hide-el')
                document.getElementById('results-count').classList.remove('hide-el')
                if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    document.getElementById('jobDetails').classList.remove('hide-el')
                }
                document.getElementById('results-count').innerHTML = `${uniqueJobsCount} Unique Openings`
                // document.querySelector('.with-shifts').classList.remove('hide-el')
            }
        }



        /**
         * 
         * Get the job details
         * @param {integer} id of the Job
         * 
         */
        async function getJobDetails(id) {
            if (debug) console.log('fn: getjobdetails')
            // id = 1704114
            // const response = await fetch(`https://${coreApi}.ayahealthcare.com/AyaHealthCareWeb/Job/${id}`)
            // const jobDetail = await response.json()

            document.querySelector('.with-shifts').classList.add('hide-el')

            let jobDetail  = jobsData.filter(function(o){return o.jobID == id;} );
            jobDetail = jobDetail[0]

            if (debug) console.log('var: jobdetail', jobDetail, id)
        

            // State CDN image with CA fallback
            let imageState = !jobDetail.stateAbbrev ? 'ca' : jobDetail.stateAbbrev.replace(/[\s.,'-]+/, "-").toLowerCase()
            let imageNum = Math.floor(Math.random()*3+1)
            cdnUrl = `https://cdn.ayahealthcare.com/marketingpublic/${imageState}_${imageNum}--780x780.webp`

            jobDetailData = jobDetail;
            
        }


        // Dropdown search button event listener to update results
        let showResultsBtn = document.querySelectorAll('.searchnow');
        showResultsBtn.forEach((s) => {
            s.addEventListener('click', function() {
                initialSearch = true
                // h1.textContent = 'Travel Healthcare Jobs'
                // h2.textContent = 'Browse hospital jobs nationwide'
                buildSearchQuery()
                currPage = 1
                renderResults()
                updateHistory()
            })
        })
        
    } // end search page



}).catch(error => {
    if (debug)
        console.log('Error: ', error)
});
